// removed by extract-text-webpack-plugin
module.exports = {"card":"y0bQm3SvlRZ7UsLG-7ic2","amount":"_2eznA8UkkqKmXg_u4WLK3X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Payment/HistoryCard.scss
// module id = 1122
// module chunks = 0